import FormRow from '../../FormRow'
import {
  Field,
  RichTextEditor,
  SelectCheckbox
} from '../../../../react-final-form-wrappers'
import { OnChange } from 'react-final-form-listeners'
import { client } from '../../../../client/client'
import { useFieldValue } from '../../../../hooks/useFieldValue'
import { useTranslation } from 'react-i18next'
import AuthenticationService from '../../../../services/AuthenticationService'
import { useForm } from 'react-final-form'
import { useState } from 'react'
import TemplateToolbarButton from '../../../../components/RichTextEditor/TemplateToolbarButton'

const AcquaintanceSection = () => {
  const { t } = useTranslation('acquaintanceSection')
  const programId = useFieldValue('id')
  const practiceId = useFieldValue('practice.id')
  const userId = AuthenticationService.getUserId()
  const form = useForm()
  const [replaceText, setReplaceText] = useState(null)
  const [replaceKey, setReplaceKey] = useState(0)

  const insertTemplate = async () => {
    const response = await client.getTemplate(userId, practiceId, 'acquaintanceNote')
    const text = response?.status === 'success' ? response?.data?.template?.text : ''
    setReplaceText(text || '\u200b')
    setReplaceKey((k) => k + 1)
  }

  const options = [
    { id: 15, name: t('scheduledIntake') },
    { id: 17, name: t('clientRefrains') },
    { id: 18, name: t('clientUnavailable') },
    { id: 999, name: t('clientCanceledIntroductionMeeting') },
    { id: 39, name: t('patientTooSevereForBasicCare') }
  ]

  const TemplateButton = () => (
    <TemplateToolbarButton
      onClick={insertTemplate}
      title={t('template', { ns: 'settingsPage' })}
    />
  )

  return (
    <>
      <FormRow>
        <Field
          name="acquaintanceNote"
          label={t('acquaintanceNote')}
          component={RichTextEditor}
          replaceMarkdown={replaceText}
          replaceKey={replaceKey}
          toolbarCustomButtons={[<TemplateButton key="template" />]}
        />
      </FormRow>
      <FormRow>
        <Field
          name="acquaintanceOutcome"
          label={t('acquaintanceOutcome')}
          component={SelectCheckbox}
          options={options}
        />
      </FormRow>
      <OnChange name="acquaintanceOutcome">
        {(option, previousOption) => {
          if (option && option.id) {
            client.updateFunnelStatusByTreatmentProgram(programId, option.id)
          }
        }}
      </OnChange>
    </>
  )
}

export default AcquaintanceSection
